import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaBriefcase,
  FaCertificate,
  FaChalkboardTeacher,
  FaEnvelopeOpenText,
  FaFileAlt,
  FaFileContract,
  FaGoogle,
  FaGraduationCap,
  FaHandshake,
  FaProjectDiagram,
  FaTachometerAlt,
  FaUserCheck,
  FaUserGraduate,
  FaUserPlus,
  FaUserTie,
  FaVideo,
  FaList,
  FaRegImages,
  FaUser,
  FaListAlt,
  FaCalendarAlt,
  FaChartBar,
} from "react-icons/fa";
import { FaBookMedical } from "react-icons/fa";
import { LuCopyPlus } from "react-icons/lu";
import { GiTempleGate } from "react-icons/gi";
import { FaFilter } from "react-icons/fa";
import { GrAlert, GrMoney } from "react-icons/gr";
import { VscDashboard } from "react-icons/vsc";






import { FaTasks } from "react-icons/fa";

export const Sidebar = () => {
  const [sidebarMenu, setSidebarMenu] = useState<any[]>([]);

  useEffect(() => {
    const loginData: any = sessionStorage.getItem("loginData");
    const data = JSON.parse(loginData);
    getSidebarMenuList(data?.role?.roleName);
  }, []);

  let getSidebarMenuList = (role: string) => {
    let list: any = [];
    if (role === "user") {
      list = [
        {
          name: "Dashboard",
          route: "/dashboard",
          icon: FaTachometerAlt, // Icon changed to FaTachometerAlt for dashboard
        },
        {
          name: "Internships",
          route: "/user/internships",
          icon: FaBriefcase, // Icon changed to FaBriefcase for internships
        },
        {
          name: "Certificates",
          route: "/user/certificates",
          icon: FaCertificate, // Icon changed to FaCertificate for certificates
        },
        {
          name: "LMS",
          route: "/user/cms",
          icon: FaChalkboardTeacher, // Icon changed to FaChalkboardTeacher for LMS
        },
        {
          name: "Career Guidance",
          route: "/user/training",
          icon: FaUserGraduate, // Icon changed to FaUserGraduate for career guidance
        },
        {
          name: "CGPA Building",
          route: "/user/projects",
          icon: FaProjectDiagram, // Icon changed to FaProjectDiagram for CGPA building
        },
        {
          name: "Admit Letter",
          route: "/user/letterhead",
          icon: FaFileContract, // Icon changed to FaFileContract for LOA
        },
        {
          name: "LOA",
          route: "/user/loa",
          icon: FaFileAlt, // Changed to FaFileAlt for LOA (document icon)
        },
        {
          name: "Resume Access",
          route: "/user/resume",
          icon: GiTempleGate
          , 
        },
      ];
    } else if (role === "admin") {
      list = [
        {
          name: "Eduexpose Interns",
          route: "/dashboard",
          icon: FaUserGraduate, 
        },
        {
          name: "Prospect List",
          route: "/admin/prospectlist",
          icon: FaUserTie, // Changed to FaUserTie (business person icon)
        },
        {
          name: "Upload List",
          route: "/admin/uploadList",
          icon: FaHandshake, // Changed to FaHandshake (handshake icon)
        },
        {
          name: "Registered Students",
          route: "/register/students",
          icon: FaUserCheck, // Changed to FaUserCheck (user check icon)
        },
        {
          name: "Subscribers",
          route: "/admin/queries",
          icon: FaEnvelopeOpenText, // Changed to FaEnvelopeOpenText (envelope icon)
        },
        {
          name: "Private Cerificates",
          route: "/admin/privateCerificate",
          icon: FaCertificate, 
        },
        {
          name: "Admit Letter",
          route: "/admin/loa",
          icon: FaFileAlt, // Changed to FaFileAlt for LOA (document icon)
        },
        {
          name: "Percentage Access",
          route: "/admin/percentageList",
          icon: FaTasks, // Changed to FaFileAlt for LOA (document icon)
        },
        {
          name: "Amb",
          route: "/admin/certificatelist",
          icon: FaCertificate, // Changed to FaCertificate
        },
        {
          name: "Resume Access",
          route: "/admin/resumeAccess",
          icon: GiTempleGate, 
        },
        {
          name: "Filter access",
          route: "/admin/filterAccessList",
          icon: FaFilter, 
        },
        
      ];
    } else if (role === "support") {
      list = [
        {
          name: "Manage Courses",
          route: "/dashboard",
          icon: FaChalkboardTeacher, // Changed to FaChalkboardTeacher
        },
        {
          name: "Certificates",
          route: "/support/certificatelist",
          icon: FaCertificate, // Changed to FaCertificate
        },
        {
          name: "LMS Videos",
          route: "/support/lmsvideolist",
          icon: FaVideo, // Changed to FaVideo
        },
        {
          name: "Project",
          route: "/support/projectlist",
          icon: FaProjectDiagram, // Changed to FaProjectDiagram
        },
        {
          name: "Project Data",
          route: "/support/projectData",
          icon: FaProjectDiagram, // Changed to FaProjectDiagram
        },
        {
          name: "Student CGPA",
          route: "/support/cgpalist",
          icon: FaGraduationCap, // Changed to FaGraduationCap
        },
        {
          name: "Career Guidances",
          route: "/support/careerGuidances",
          icon: FaBriefcase, // Changed to FaBriefcase
        },
        {
          name: "Batch List",
          route: "/support/batchlist",
          icon: LuCopyPlus,
        },
        {
          name: "Google Meet List",
          route: "/support/meetslist",
          icon: FaGoogle,
        },
        {
          name: "LOA",
          route: "/support/loa",
          icon: FaFileAlt,
        },
        {
          name: "Task List",
          route: "/support/tasklist",
          icon: FaTasks,
        },
        {
          name: "Added SignUpList",
          route: "/support/signUpList",
          icon: FaUserPlus,
        },
        {
          name: "Alert",
          route: "/support/alert",
          icon: GrAlert,
        },
      ];
    } else if (role === "manager") {
      list = [
        {
          name: "Eduexpose Interns",
          route: "/dashboard",
          icon: FaUserGraduate, // Changed to FaUserGraduate (graduate icon)
        },
        {
          name: "Conversion list",
          route: "/manager/conversionList",
          icon: FaUserCheck, // Changed to FaUserCheck (user check icon)
        },
        {
          name: "Upload List",
          route: "/manager/uploadList",
          icon: FaHandshake, // Changed to FaHandshake (handshake icon)
        },
        {
          name: "Amb",
          route: "/admin/certificatelist",
          icon: FaCertificate, // Changed to FaCertificate
        },
      ];
    } else if (role === "bdi") {
      list = [
        {
          name: "User Profile",
          route: "/dashboard",
          icon: FaUser
        },
        {
          name: "Conversion List",
          route: "/bdi/conversionlist",
          icon: GrMoney, // Changed to FaCertificate
        },
        {
          name: "Crm Dashboard",
          route: "/crm/dashboard",
          icon: VscDashboard, // Changed to FaCertificate
        },
        {
          name: "Student List",
          route: "/bdi/studentList",
          icon: VscDashboard, // Changed to FaCertificate
        },
      ];
    }
    else if (role === "exam_admin") {
      list = [
        {
          name: "Dashboard",
          route: "/dashboard",
          icon: VscDashboard,
        },
        {
          name: "College List",
          route: "/exam/collegeList",
          icon: FaBookMedical,
        },
        {
          name: "Banner List",
          route: "/exam/bannerList",
          icon: FaRegImages, 
        },
        {
          name: "Manage Questions",
          route:"/exam/manageCollegeList",
          icon: FaListAlt,
        },
        {
          name: "Results",
          route: "/exam/manageResultList",
          icon: FaChartBar,
        },
        // {
        //   name: "Profile",
        //   route: "/exam/profile",
        //   icon: FaUser,
        // },
      ];
    }
    
    setSidebarMenu(list);
  };

  return (
    <div className="primary-bg text-white">
      <div className="sidebar_a">
        <ul className="nav-list px-0 pt-4">
          {sidebarMenu.map((data: any, index: number) => (
            <NavLink
              key={index}
              to={data.route}
              className="text-decoration-none text-white sidemenu-list-item"
            >
              <li className="py-2 pe-5 text-start ps-3 py-3 sidemenu-item px-4 border-bottom border-white">
                <data.icon className="me-2" />
                &nbsp; &nbsp;&nbsp;
                {data.name}
              </li>
            </NavLink>
          ))}
        </ul>
      </div>
    </div>
  );
};
